var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import MuiAvatar from '@mui/material/Avatar';
import clsx from 'clsx';
import { makeStyles } from '../';
const useStyles = makeStyles({
    small: {
        height: 32,
        width: 32,
    },
}, { name: 'Avatar' });
/** Extends MUI's Avatar component with a size prop. */
const Avatar = (_a) => {
    var { size = 'default' } = _a, rest = __rest(_a, ["size"]);
    const classes = useStyles();
    return (_jsx(MuiAvatar, Object.assign({ classes: {
            root: clsx(size !== 'default' && classes[size]),
        } }, rest), void 0));
};
export default Avatar;
